module.exports = __webpack_public_path__ + "summernote.cca79100fbabf9354968.eot";


//////////////////
// WEBPACK FOOTER
// /app/vendor/summernote/font/summernote.eot
// module id = ../../../../../vendor/summernote/font/summernote.eot
// module chunks = styles